import { render } from "./DataBackupRestore.vue?vue&type=template&id=51480046&scoped=true"
import script from "./DataBackupRestore.js?vue&type=script&lang=js&external"
export * from "./DataBackupRestore.js?vue&type=script&lang=js&external"

import "./DataBackupRestore.scss?vue&type=style&index=0&id=51480046&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51480046"]])

export default __exports__